export default "__VITE_ASSET__hlo9LgFK__"